// @flow
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import { withStyles } from '@material-ui/core/styles';
import OrderSku from '../order-sku/OrderSku';
import {
	MACHINE_ORDER,
	ACTIVE_ORDER,
} from '../../constants';

const DoorStep = withStyles({
	root: {
		whiteSpace: 'pre-line',
		'& .MuiStepIcon-root': {
			color: 'transparent',
			border: '1px solid #808c89',
			borderRadius: '50%',
			'& .MuiStepIcon-text': {
				fill: '#808c89',
			},
		},
		'& .MuiStepLabel-label': {
			color: 'black',
			fontWeight: 500,
		},
		'& .MuiStepConnector-line': {
			borderColor: '#808c89',
		},
	},
})(Step);

const useStyles = makeStyles((theme) => ({
	stepper: {
		margin: 'auto',
		backgroundColor: 'transparent !important',
		padding: '0 !important',
	},
	doorInfoContainer: {
		display: 'flex',
		marginBottom: 6,
		width: '100%',
		padding: '0 14px',
		fontSize: 13,
	},
	itemsContainer: {
		margin: '0 14px',
		alignSelf: 'stretch',
	},
	billValue: {
		backgroundColor: '#fff',
		color: '#6b6b6b',
		fontSize: ' 14px',
		marginBottom: 10,
		margin: '0 14px 10px',
		alignSelf: 'stretch',
		'& > *': {
			padding: '10px 12px',
		},
		'& .delivery': {
			height: 50,
			borderBottom: '1px dashed #6b6b6b',
			lineHeight: '30px',
		},
		'& .invoiceText': {
			height: 70,
			lineHeight: '50px',
			color: 'black',
		},
	},
}));

type Props = {
	orderDetails: any,
	doorSteps: Array<string>,
	isVSorder: boolean,
	deliveryAmount: number,
	totalBillValue: number,
	cancelledOrderIds: Set<string>,
};

function OrderDetailsSection({
	orderDetails,
	doorSteps,
	isVSorder,
	deliveryAmount,
	totalBillValue,
	cancelledOrderIds,
}: Props) {
	const styles = useStyles();

	return (
		<section>
			{/* Door Steps - Only for machine orders with active status and not cancelled */}
			{orderDetails.type_of_order === MACHINE_ORDER &&
				orderDetails.status === ACTIVE_ORDER &&
				doorSteps &&
				doorSteps.length > 0 &&
				!cancelledOrderIds.has(orderDetails.order_id) && (
				<section className={styles.doorInfoContainer}>
					<Stepper nonLinear alternativeLabel classes={{ root: styles.stepper }}>
						{doorSteps.map((label) => (
							<DoorStep disabled key={label} classes={{ root: styles.step }}>
								<StepLabel>{label}</StepLabel>
							</DoorStep>
						))}
					</Stepper>
				</section>
			)}

			{/* Order Items - Product List */}
			<section className={styles.itemsContainer}>
				{orderDetails.order_items &&
					Array.isArray(orderDetails.order_items) &&
					orderDetails.order_items.map((item, index) => (
						<OrderSku sku={item} orderType={orderDetails.type_of_order} key={index} />
					))}
			</section>

			{/* Total Bill Value */}
			<section className={styles.billValue}>
				{isVSorder && (
					<section className='delivery' style={{}}>
						Delivery Fee
						<span style={{ float: 'right' }}>&#x20b9; {deliveryAmount}</span>
					</section>
				)}
				<div className='invoiceText'>
					Total Bill Value
					<span style={{ float: 'right' }}>&#x20b9; {totalBillValue}</span>
				</div>
			</section>
		</section>
	);
}

export default OrderDetailsSection;